import type { NavItem, SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'
import { morningLoft } from '@/constants/media'

export const siteConfig: SiteConfig = {
    name: 'Unity Space Berlin',
    shortName: 'Unity Space',
    description: "An event collective and haven in Berlin-Kreuzberg for meditation, workshops, retreats, team outings, wellness and longevity experiences. Paul-Lincke-Ufer 40, 10999 Berlin.",
    url: getOrigin(),
    ogImage: morningLoft.src
}

export const contact = {
    organisation: 'Unity Dome Berlin',
    street: 'Paul-Lincke-Ufer 40',
    entrance: 'Backyard #4, ground floor, entrance on the right',
    postcode: '10999',
    city: 'Berlin',
    district: 'Kreuzberg',
    mapsUrl: 'https://maps.app.goo.gl/qtxvxx2YH6sSiU1U6',
    email: 'contact@unityspace.berlin',
    bookingUrl: 'https://t.me/Joejung',
    bookingHandle: '@Joejung',
    communityUrl: 'https://t.me/+chF7w1y5CWdhNDQy'
}

export const navigation: Array<NavItem> = [
    { label: 'The space', hash: '#venue' },
    { label: 'What we offer', hash: '#offer' },
    { label: 'Programme', hash: '#programme' },
    { label: 'Voices', hash: '#voices' },
    { label: 'Stay connected', hash: '#connect' }
]

export const copyrightYear = 2026
